import styled from 'styled-components'

export default styled.div`
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
`

export const Button = styled.button`
  background-color: ${(props) => props.theme.palette.gray[300]};
  color: ${(props) => props.theme.palette.gray[800]};
  border: 0;
  width: auto;
  min-width: 6.4rem;
  max-width: 40rem;
  font-size: 1.4rem;
  font-weight: 500;
  text-transform: uppercase;
  height: 3.6rem;
  border-radius: 4px;
  outline: none;
  cursor: pointer;
  display: inline-flex;
  justify-content: center;
  align-items: center;
  padding: 0 1.6rem;
  margin-top: 3rem;
  transition: background-color 0.2s ease, box-shadow 0.2s ease, transform 0.1s ease;
  box-shadow: ${(props) => props.theme.shadows[2]};
  letter-spacing: 0.02em;

  &.primary {
    background-color: ${(props) => props.theme.palette.primary};
    color: ${(props) => props.theme.palette.contrast};
    box-shadow: ${(props) => props.theme.shadows[2]};

    &:hover {
      background-color: ${(props) => props.theme.palette.gray[800]};
      box-shadow: ${(props) => props.theme.shadows[4]};
    }
  }

  &.black {
    background-color: black;
    color: white;
  }

  &:focus {
    outline: none;
  }

  &:hover {
    background-color: ${(props) => props.theme.palette.gray[200]};
    box-shadow: ${(props) => props.theme.shadows[4]};
  }

  &:active {
    transform: translateY(1px);
    box-shadow: ${(props) => props.theme.shadows[1]};
  }

  &.disabled {
    cursor: default !important;
    background-color: ${(props) => props.theme.palette.gray[100]};
    color: ${(props) => props.theme.palette.gray[500]};
    box-shadow: none;
    transform: none;

    &:hover {
      background-color: ${(props) => props.theme.palette.gray[100]};
      box-shadow: none;
    }
  }

  &.button__loading {
    cursor: default !important;
    background-color: ${(props) => props.theme.palette.gray[100]};
    width: 3.6rem;
    min-width: 3.6rem;
    padding: 0;
    box-shadow: none;
  }

  .button__loader {
    width: 3rem !important;
    height: 3rem !important;

    svg {
      width: 3rem;
      height: 3rem;
    }
  }
`
